import { Divider, Grid, Stack } from "@mui/material";
import SalaryIncreaseConfigToggle from "./SalaryIncreaseConfigToggle";
import { SalaryComponentRow } from "../types";
import { useAppSelector } from "../../../../app/hooks";

type Props = {
  rows: SalaryComponentRow[];
  handleExpands: (salaryComponent: string) => void;
  expands: Record<string, boolean>;
};

const SalaryIncreaseConfigRows = ({ rows, handleExpands, expands }: Props) => {
  const { salaryComponent: salaryComponentTranslations } = useAppSelector(
    (state) => state.localized,
  );

  return (
    <Grid item xs={12} mt={1}>
      <Stack pl={1}>
        {rows.map((row, index, array) => (
          <SalaryIncreaseConfigToggle
            key={row.code}
            index={index}
            title={salaryComponentTranslations[row.code] || row.code}
            handleOpen={handleExpands}
            open={expands[row.code]}
            salaryComponent={row.code}
            margin={index === array.length - 1}
            ktaMode={false}
          />
        ))}
      </Stack>
      <Divider />
    </Grid>
  );
};

export default SalaryIncreaseConfigRows;
